<template>
  <div class="form">
    <el-form :label-position="labelPosition" label-width="100px" :model="form" style="padding-bottom: 35px;">
      <el-form-item :label="$t('message.title.type') + ':'" required>
        <el-select v-model="form.subClassId" filterable :placeholder="$t('message.placeholder.select')" size="small"
          style="width:100%" @change="getAutoNumber">
          <i slot="prefix" class="el-input__icon el-icon-warning warning" v-show="subClassChanged"></i>
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <div class="warning-title" :style="{ visibility: subClassChanged ? 'visible' : 'hidden' }"> !
        {{ $t('message.tips.changeSubClass') }}
      </div>
      <!-- <el-form-item >
        <div> <i  class="el-input__icon el-icon-warning warning" v-show="subClassChanged"></i> xxxx </div>
      </el-form-item> -->
      <el-form-item :label="$t('message.table.code') + ':'" required>
        <el-input v-model="form.name" size="small" :disabled="autoNumber" :placeholder="editName"></el-input>
      </el-form-item>
      <el-form-item :label="$t('message.table.versionNumber') + ':'" v-if="baseId == 101" required>
        <!-- <el-input v-model="form.name" size="small" ></el-input> -->
        <el-select v-model="version" :placeholder="$t('message.placeholder.select')" size="small" style="width:100%">
          <el-option v-for="item in versionList" :key="item.value" :label="item.text" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item style="float:right;margin-bottom: 25px;">
        <el-button type="primary" @click="submitForm" size="small">{{
          $t("message.button.submit")
        }}</el-button>
        <el-button @click="cancel" type="success" size="small">{{
          $t("message.button.cancel")
        }}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      labelPosition: "right",
      form: {
        subClassId: "",
        name: "",
      },
      version: '',
      // editName:'',
      options: [],
      autoNumber: false,

      saveUrl: [
        { baseId: '101', url: '/pmdm/items/saveAsItem' },
        { baseId: '104', url: '/pmdm/changes/saveAsChange' },
        { baseId: '105', url: '/pmdm/manufacturers/saveAsManufacturer' },
        { baseId: '106', url: '/pmdm/manufacturerPart/saveAsManufacturerPart' },
        { baseId: '401', url: '/pmdm/quality/saveAsQuality' },
        { baseId: '501', url: '/pmdm/technology/saveAsTechnology' },
        { baseId: '502', url: '/pmdm/resource/saveAsResource' },
      ]
    };
  },
  props: ["versionList"],
  computed: {
    // autoNumber() {
    //   return !this.form.subClassId;
    // },
    subClassChanged() {
      return this.form.subClassId != this.$store.state.objectId.subClassId;
    },
    editName() {
      return this.autoNumber ? this.$t('message.title.autoNumber') : this.$t('message.tips.inputName')
    }
  },
  methods: {
    getSubClass() {
      // let baseId = this.$store.state.objectId.classId.toString().substr(0, 3);
      axios
        .get('pmdm/admin/cls/getSubClses?clsId=' + this.$store.state.objectId.classId)
        .then((res) => {
          this.options = res.data.object.subClses.map((i) => ({ value: i.id, label: i.name, autoNumber: i.autoNumber != -1 }));
          this.autoNumber = this.options.find(i => i.value == this.form.subClassId).autoNumber
        });
    },
    getAutoNumber() {
      this.form.name = '';
      axios.get('/pmdm/admin/autonumber/getNextNumber?subClsId=' + this.form.subClassId).then(res => {
        console.log(res.data.object.nextNumber);
        this.autoNumber = !!res.data.object.nextNumber;
        // this.editName = this.autoNumber ? '编号自动生成' : '请输入名称' 
      })
    },

    submitForm() {

      if ((!this.autoNumber && !this.form.name) || (this.baseId == 101 && !(this.version + ''))) {
        this.$message.error(this.$t('message.warning.required'));
        return
      }
      let obj = {
        ...this.form,
        currentId: this.$store.state.objectId.id,
        // currentChangeId:this.$store.state.change_info.changeId,
      }

      const saveUrlList = new Map([
        [101, '/pmdm/items/saveAsItem'],
        [104, '/pmdm/changes/saveAsChange'],
        [105, '/pmdm/manufacturers/saveAsManufacturer'],
        [106, '/pmdm/manufacturerPart/saveAsManufacturerPart'],
        [401, '/pmdm/quality/saveAsQuality'],
        [501, '/pmdm/technology/saveAsTechnology'],
        [502, '/pmdm/resource/saveAsResource'],
      ])
      const url = saveUrlList.get(Number(this.baseId))
      console.log(this.baseId, url);

      axios.post(url, obj).then(res => {
        // console.log(res);
        this.$emit('close')
        if (res.data.code == 200) {
          // let link = {
          //   itemClassId: res.data.object.classId,
          //   itemId: res.data.object.id,
          //   itemSubClassId: res.data.object.subclassId,
          // };
          // link[0] = res.data.object.name;
          // this.getRouteLink(link);   
          const item = {
            ...res.data.object,
            name: res.data.object.name
          }
          this.getLink(item);

          this.$store.commit("setPageRefresh");
        }
      })
    },
    cancel() {
      this.$emit('close')
    },
  },
  created() {
    this.baseId = this.$store.state.objectId.classId.toString().substr(0, 3);
    this.form.subClassId = this.$store.state.objectId.subClassId;
    this.getSubClass();
  },
};
</script>

<style scoped>
.form {
  padding: 25px 60px;
}

.warning-title {

  font-size: 12px;
  /* margin: -25px 0 20px 112px;*/
  margin: -15px 0 20px 112px;
  color: #e6a23c;
  /* height: ; */
}

.warning {
  color: #e6a23c;
  font-size: 14px;
}
</style>
